class MainHeader extends HTMLElement {
  constructor() {
	super()
        this.mobileMenuGroup = this.querySelectorAll(".menu-drawer__menu-item--mainlist")
        this.init()
    }

    init(){
        this.mobileMenuGroup.forEach((dom,index)=>{
            const button = dom.querySelector(".open-children-button")
            const content = dom.nextElementSibling
            button?.addEventListener("click",(event)=>{
                event.preventDefault();
                event.stopPropagation();
                dom.classList.toggle("open")
                if(dom.classList.contains("open")){
                    const fullHeight = content.scrollHeight;
                    content.style.height = fullHeight + 'px';
                }else{
                    content.style.height = '0px';
                }
            })
        })
    }
}

reg("header-component", MainHeader);